import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";

import { SidebarInset } from "../components/ui/sidebar";
import { UsagePage } from "../components/usage/UsagePage";
import { isUsageTabId, resolveUsageTab, type UsageTabId } from "../components/usage/usageSections";

function UsageRouteLayout() {
  const navigate = useNavigate();
  const { tab } = Route.useSearch();

  return (
    <SidebarInset className="h-full min-h-0 overflow-hidden overscroll-y-none bg-background text-foreground isolate">
      {/* No spacer row.
          This used to reserve a header's worth of height (44px web, 52px
          Electron) to stand in for a per-surface header this route does not
          render, described as matching the settings shell. Settings has since
          removed the same pair of divs: `AppTopBar` is mounted above every
          route by `AppSidebarLayout` and already occupies that strip and owns
          the drag region, so the reservation only pushed the whole page down by
          a bar height and opened a dead band above the content. */}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col bg-background text-foreground">
        <div className="flex min-h-0 flex-1 flex-col">
          <UsagePage
            activeTab={resolveUsageTab(tab)}
            onTabChange={(next: UsageTabId) => {
              // Replace, not push: switching section is changing what you are
              // looking at, and a back button that walks three sections before
              // leaving the page is the wrong model.
              void navigate({ to: "/usage", search: { tab: next }, replace: true });
            }}
          />
        </div>
      </div>
    </SidebarInset>
  );
}

export const Route = createFileRoute("/usage")({
  beforeLoad: ({ context }) => {
    if (context.authGateState.status !== "authenticated") {
      throw redirect({ to: "/login", replace: true });
    }
  },
  validateSearch: (search: Record<string, unknown>): { tab?: UsageTabId } => {
    const tab = search["tab"];
    return isUsageTabId(tab) ? { tab } : {};
  },
  component: UsageRouteLayout,
});
